/**
 * Constantes relacionadas con la integración de Wompi
 * Centraliza claves de sessionStorage para evitar errores tipográficos
 */

/**
 * Claves de sessionStorage utilizadas para persistir datos de transacciones Wompi
 */
export const WOMPI_SESSION_KEYS = {
  REFERENCE_CODE: 'wompi_reference_code',
  PAYMENT_ID: 'wompi_payment_id',
  AMOUNT: 'wompi_amount',
  CURRENCY: 'wompi_currency',
} as const;
